module.exports = __webpack_public_path__ + "static/media/480.7b33e2ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-oak-leaf/light/480.png
// module id = 2274
// module chunks = 2